import { render } from "./ExportModuleProperties.vue?vue&type=template&id=de695efa&scoped=true"
import script from "./ExportModuleProperties.vue?vue&type=script&lang=js"
export * from "./ExportModuleProperties.vue?vue&type=script&lang=js"

import "./ExportModuleProperties.vue?vue&type=style&index=0&id=de695efa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de695efa"]])

export default __exports__